import React from "react";
import bookIcon from './book-icon.png';

export default ({ tidbit }) => (
  <section className="did-you-know media">
    <div className="media-left image is-48x48">
      <img src={bookIcon} alt=""/>
    </div>
    <div className="media-content">
      <h3>Did you know?</h3>
      <p>{tidbit}</p>
    </div>
  </section>
)


// WEBPACK FOOTER //
// ./src/components/did-you-know/index.js